import { BBDTag, Horizontal, Texto, Vertical } from '@gravitate-js/excalibrr'
import { sortStringNumbers } from '@utils/general'
import { Popover } from 'antd'
import React from 'react'

export function SiteMarketHierarchyRenderer({ siteNumbers, sectorNames, marketNames, totalCount }) {
  // Used in conduction with a hierarchy selector to display the selected markets, sectors and sites

  const siteGroup = sortStringNumbers(siteNumbers).map((site) => <Texto key={site}>{site}</Texto>)
  const sectorGroup = sectorNames.sort().map((sector) => <Texto key={sector}>{sector}</Texto>)
  const marketGroup = marketNames.sort().map((market) => <Texto key={market}>{market}</Texto>)

  const content = (
    <div style={{ minHeight: '45px', maxHeight: '500px', minWidth: '300px', overflowY: 'scroll' }}>
      <Vertical style={{ gap: '1rem' }}>
        <Horizontal>
          <Vertical>
            <Texto weight='bold'>Markets:</Texto>
            {marketGroup}
          </Vertical>
        </Horizontal>
        <Horizontal>
          <Vertical>
            <Texto weight='bold'>Sectors:</Texto>
            {sectorGroup}
          </Vertical>
        </Horizontal>
        <Horizontal>
          <Vertical>
            <Texto weight='bold'>Sites:</Texto>
            {siteGroup}
          </Vertical>
        </Horizontal>
      </Vertical>
    </div>
  )

  if (totalCount === 0) {
    return
  }

  return (
    <Popover content={content} placement='bottomLeft'>
      <BBDTag style={{ fontWeight: 'bold' }}>{totalCount}</BBDTag>
    </Popover>
  )
}
